import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Button, Checkbox, Select, TextBox } from "@veneer/core";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import { getFieldError, getValidatedNumberInput, isValidEmail, isValidPhoneNumber, onSearchDropDown } from 'utils';
import { useAppSelector } from '@store/hooks';
import { primaryContactInformation, submitFormRef } from "@constants/case-create";
import { fetchContactDetails } from '@services/fetch-contact-details-info';
import { HelpModalPopup } from '@components/home-page/shared-components/modal-popup/help-modal-popup';

interface CreateNewContactProps {
    countryList: any[];
    countryCodes: any[];
    onSave:any;
}
type PrimaryContactInformation = typeof primaryContactInformation;
    
const CreateNewContact: React.FC<CreateNewContactProps> = ({ countryList, countryCodes, onSave }) => {  
    const { t } = useTranslation();
    const formPrimaryData = useAppSelector((state) => state.formContactPrimaryInfo.formPrimaryData);
    // const [form, setForm] = useState({name: '', email: '',phone: '',});
    const [filteredCountryCodes, setFilteredCountryCodes] = useState(countryCodes || []);
    const [filteredCountryList, setFilteredCountryList] = useState(countryList || []);
    const [filteredAltCountryCodes, setFilteredAltCountryCodes] = useState(countryCodes || []);
    const [formDetails, setFormDetails] = useState<PrimaryContactInformation>(formPrimaryData);
    const [errors, setErrors] = useState<PrimaryContactInformation>(primaryContactInformation);
    const defaultRequiredFields = ["FirstName", "LastName", "countryId", "PhoneNumber", "Email"];
    const requiredFieldsRef = useRef<string[]>(defaultRequiredFields);
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        // setForm({
        //     ...form,
        //     [e.target.name]: e.target.value,
        // });
    };
    
    useEffect(() => {
        if (formPrimaryData !== null) {
          setFormDetails({
            ...{
              "UserId": [
                "-1"
              ],
              "AccountId": "",
              "fullname": "",
              "FirstName": "",
              "LastName": "",
              "PhoneNumber": "",
              "Extension": "",
              "AlternatePhoneNumber": "",
              "AlternateExtension": "",
              "Email": "",
              "countryName": "",
              "cpf": "",
              "neighbourhood": "",
              "stateInscription": "",
              "countryId": [
                ""
              ],
              "accountType": "",
              "phNumCountryCode": [
                ""
              ],
              "phNumAlternateCountryCode": [
                ""
              ],
              "addsavedcontacts": "false"
            }, UserId: ["-1"]
          })
        }
      }, [])

    useEffect(() => {
        if (countryCodes != undefined && countryList != undefined) {
            setFilteredCountryCodes(countryCodes);
            setFilteredAltCountryCodes(countryCodes);
            setFilteredCountryList(countryList);

        }
    }, [countryList, countryCodes])
    
    
    const validateField = (name: string, value: string) => {
        let error = "";
        if (!value) {
          error = t('HPI.ErrorMessage.RequiredFields',{defaultValue:'This field is required.'});
        }
        if (
          name === "Email" && value && !isValidEmail(value)
        ) {
          error = t('HPI.ErrorMessage.InvalidEmailFormat',{defaultValue:'Invalid email format'});
        }
        if ((name === "PhoneNumber" || name === "AlternatePhoneNumber") && !isValidPhoneNumber(value)) {
          error = t('HPI.ErrorMessage.InvalidNumber',{defaultValue:'Phone number must be 8-15 digits long and contain only numbers.'});
        }
        setErrors((prevState) => ({
          ...prevState,
          [name]: error,
        }));
    
      };
      const handleInputChange = (
        v: any,
        event: React.ChangeEvent<HTMLInputElement>
      ) => {
       const { name, value } = event.target;
        setFormDetails((prevData) => ({ ...prevData, [name]: v }));
    
        if (['PhoneNumber', 'Email', 'AlternatePhoneNumber'].includes(name)) {
          setErrors((prevState) => ({
            ...prevState,
            [name]: '',
          }));
        } else {
          validateField(name, v);
        }
    
      };
    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        if(value){
          validateField(name, value);
        }
      };
    
    
      
    const onSelectChangeHandler = (selectedOption: any, k: any) => {
        setErrors(primaryContactInformation);
      setFormDetails((prevData) => ({
          ...prevData,
          [k]: [selectedOption?.value],
        }));
        if (k === 'countryId') {
          setFormDetails((prevData) => ({ ...prevData, ['countryName']: selectedOption?.label}));
        }
        validateField(k, selectedOption?.value);
      };
    
    const fetchContactInfo = useCallback(async (payload: any) => {
        try {
         // const data = await fetchContactDetails(dispatch, payload);
        //   setflgBrazil({
        //     neighbourhood: (data?.neighbourhood === "")? false:true,
        //     stateInscription: (data?.stateInscription === "")? false:true,
        //     cpf: (data?.cpf === "")? false:true,
        //   });
        //  setFormDetails((prevData) => ({ ...prevData, ...data }));
        } catch (err) {
          // setError("Failed to load contact details");
        }
      }, []);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        // Handle form submission logic here
         // console.log(form);

    };
    const clearSelectHandler = (field: any) => {
        setFormDetails((prevData) => ({ ...prevData, [field]: [""] }));
    };

    const handleAddContactSubmit = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.preventDefault();
        let valid = true;
        let newErrors: any = { ...primaryContactInformation };       
        requiredFieldsRef.current.forEach((field) => {
            if (!formDetails[field as keyof PrimaryContactInformation] || formDetails[field as keyof PrimaryContactInformation] === "") {
                newErrors[field as keyof PrimaryContactInformation] = t('HPI.ErrorMessage.RequiredFields',{defaultValue:'This field is required.'});  
            valid = false;
          }  
        });
        setErrors(newErrors);
        if (valid) {
          console.log(formDetails);
          onSave(formDetails);
          // Submit the form or perform further actions
        }
      };
      useEffect(() => {
          const specialCountryId = "a2ec3ba9-f09c-e611-80f0-3863bb2e4470";
          requiredFieldsRef.current = formDetails?.countryId?.[0] === specialCountryId
            ? [...defaultRequiredFields, "neighbourhood", "stateInscription", "cpf"]
            : defaultRequiredFields;
        }, [formDetails?.countryId?.[0]]);

    return (
        <form
            id="Profile-settings-form"
            className="profile-form"
            onSubmit={handleSubmit}
        >

            <Row>
                <Col col={12} md={6}>
                    <TextBox
                        label={t("HPI.Profilepage.savedContacts.Firstname", {
                            defaultValue: "First name",
                        })}
                        placeholder={t("HPI.Profilepage.Placeholder.EnterFirstName", {
                            defaultValue: "Enter first name",
                        })}
                        separateLabel
                        required
                        className="textbox"
                        name="FirstName"
                        value={formDetails.FirstName}
                        error={!!errors.FirstName}
                        helperText={errors.FirstName}
                        onChange={(v: any, e) => handleInputChange(v, e)}

                    />
                </Col>
                <Col col={12} md={6}>
                    <TextBox
                        label={t("HPI.Profilepage.savedContacts.LastName", {
                            defaultValue: "Last name",
                        })}
                        placeholder={t("HPI.Profilepage.Placeholder.EnterLastName", {
                            defaultValue: "Enter last name",
                        })}
                        separateLabel
                        required
                        className="textbox"
                        name="LastName"
                        value={formDetails.LastName}
                        error={!!errors.LastName}
                        helperText={errors.LastName}
                        onChange={(v: any, e) => handleInputChange(v, e)}

                    />
                </Col>

                <Col md={6} lg={2}>
                    <Select
                        separateLabel
                        options={filteredCountryCodes ||[]}
                        showSearch
                        clearIcon={false}
                        required
                        name="countryId"
                        value={formDetails?.countryId || []}
                        label={t('HPI.ProfilePage.cs.SelectCountryCode', { defaultValue: 'Code' })}
                        placement="bottom"
                        placeholder={t('HPI.ProfilePage.cs.SelectCountryCode', { defaultValue: 'Code' })}
                        className="textbox country-code"
                        onSearch={(value: any) => {
                            let filtered: any = onSearchDropDown(countryCodes, value);
                            setFilteredCountryCodes(filtered);
                        }}
                        onClear={() => {
                            clearSelectHandler("countryId");
                        }}
                        onChange={(selectedOption: any) =>
                            onSelectChangeHandler(selectedOption, "countryId")
                        }
                        {...getFieldError(errors, "countryId")}
                    />
                </Col>
                <Col lg={4} md={6} >
                    <label className="custom-label">{t("HPI.CreateCase.Contactinformation.Phonenumber", { defaultValue: 'Phone Number' })}
                    </label>
                    <TextBox
                        placeholder={t('HPI.CreateCase.Placeholder.EnterPhoneNumber', { defaultValue: 'Enter phone number' })}
                        separateLabel
                        required
                        className="textbox"
                        value={formDetails.PhoneNumber}
                        name="PhoneNumber"
                        onChange={(v: any, e) => {
                            const value = getValidatedNumberInput(v, 15); 
                            if (value.length <= 15) {
                            handleInputChange(value, e);
                            }
                        }}
                        onBlur={(e) => handleBlur(e)}
                        error={!!errors.PhoneNumber}
                        helperText={errors.PhoneNumber}
                    />
                </Col>
                <Col md={6}>
                    <TextBox
                        label={t("HPI.CreateCase.Contactinformation.Extension", { defaultValue: 'Extension' })}
                        name="Extension"
                        placeholder={t('HPI.CreateCase.Placeholder.EnterExtension', { defaultValue: 'Enter extension' })}
                        separateLabel
                        className="textbox"
                        value={formDetails.Extension}
                        onChange={(v: any, e) => {
                            const value = getValidatedNumberInput(v, 5); 
                            if (value.length <= 5) {
                            handleInputChange(value, e);
                            }
                        }}

                    />
                </Col>
                <Col md={6} lg={2}>
                   <Select
                        separateLabel
                        className="textbox country-code"
                        placement="bottom"
                        options={filteredAltCountryCodes}
                        showSearch
                        name="phNumAlternateCountryCode"
                        label={t('HPI.ProfilePage.cs.SelectCountryCode',{defaultValue:'Code'})}
                        placeholder={t('HPI.ProfilePage.cs.SelectCountryCode',{defaultValue:'Code'})}
                        value={formDetails.phNumAlternateCountryCode}
                        helperTextVisibility="auto"
                        onClear={() => {
                            clearSelectHandler("phNumAlternateCountryCode");
                        }}
                        onChange={(selectedOption: any) =>
                            onSelectChangeHandler(selectedOption, "phNumAlternateCountryCode")
                        }
                        onSearch={(value: any) => {
                            let filtered: any = onSearchDropDown(countryCodes, value);
                            setFilteredAltCountryCodes(filtered);
                        }}
        
                    />
                </Col>
                <Col lg={4} md={6}>
                        
                          <TextBox
                            placeholder={t('HPI.Profilepage.Placeholder.EnterAlternatePhoneNumber',{defaultValue:'Enter alternate phone number'})}
                            separateLabel
                            label={t("HPI.CreateCase.contactinformation.alternatehelpdesk",{defaultValue:'Alternate Phone Number'})}
                            value={formDetails.AlternatePhoneNumber}
                            name="AlternatePhoneNumber"
                            onChange={(v: any, e) => {
                              const value = getValidatedNumberInput(v, 15); 
                              if (value.length <= 15) {
                                handleInputChange(value, e);
                              }
                            }}
                            onBlur={(e) => handleBlur(e)}
                            error={!!errors.AlternatePhoneNumber}
                            helperText={errors.AlternatePhoneNumber}
                            className="textbox"
                          />
                        </Col>
                <Col md={6}>
                    <TextBox
                        label={t("HPI.CreateCase.Contactinformation.Extension", { defaultValue: 'Extension' })}
                        name="Extension"
                        placeholder={t('HPI.CreateCase.Placeholder.EnterExtension', { defaultValue: 'Enter extension' })}
                        separateLabel
                        className="textbox"

                    />
                </Col>
                <Col md={6}>
                    <Select
                        required
                        showSearch
                        placement="bottom"
                        options={filteredCountryList || []}
                        label={t("HPI.CreateCase.address.CountryRegion", { defaultValue: 'Country/Region' })}
                        helperTextVisibility="auto"
                        onSearch={(value: any) => {
                            let filtered: any = onSearchDropDown(countryList, value);
                            setFilteredCountryList(filtered);
                        }}
                        separateLabel
                        placeholder={t('HPI.CreateCase.address.CountryRegion', { defaultValue: 'Country/Region' })}
                        name="countryId"
                        className="textbox"
              value={formDetails?.countryId || []}
                        clearIcon={false}
                        onChange={(selectedOption: any) =>
                            onSelectChangeHandler(selectedOption, "countryId")
                        }
                        {...getFieldError(errors, "countryId")}
                    />
                </Col>

                <Col md={6}>
                    <TextBox
                    separateLabel
                    label={t("HPI.CreateCase.Contactinformation.Email",{defaultValue:'Email'})}
                    type="email"
                    name="Email"
                    required
                    placeholder={t('HPI.CreateCase.Placeholder.EnterEmail',{defaultValue:'Enter email'})}
                    value={formDetails.Email}
                    onChange={(v: any, e) => handleInputChange(v, e)}
                    onBlur={(e) => handleBlur(e)}
                    error={!!errors.Email}
                    helperText={errors.Email}
                    className="textbox"
                    />
                </Col>


            </Row>
             {(formDetails?.countryId || []).includes(
                    "a2ec3ba9-f09c-e611-80f0-3863bb2e4470"
                  ) && (
                      <>
                        <Row>
                          <Col md={6}>
                            <TextBox
                              separateLabel
                              // disabled={isDisabledFeild(formDetails.neighbourhood)}
                              label={t("HPI.CreateCase.Contactinformation.Neighborhood",{defaultValue:'Neighborhood'})}
                              required
                              //disabled={flgBrazil.neighbourhood }
                              name="neighbourhood"
                              placeholder={t('HPI.CreateCase.Placeholder.EnterNeighborhood',{defaultValue:'Enter neighborhood'})}
                              //onChange={(v: any, e) => handleInputChange(v, e)}
                              value={formDetails.neighbourhood}
                              error={!!errors.neighbourhood}
                              helperText={errors.neighbourhood}
                              className="textbox"
                            />
                          </Col>
            
                          <Col md={6}>
                            <TextBox
                              separateLabel
                              required
                              // disabled={flgBrazil.cpf}
                              label={t("HPI.CreateCase.Contactinformation.CPF_CNPJ",{defaultValue:'CPF CNPJ'})}
                              name="cpf"
                              placeholder={t('HPI.CreateCase.Placeholder.EnterCPF/CNPJ',{defaultValue:'Enter CPF/CNPJ'})}
                              // disabled={isDisabledFeild(formDetails.cpf)}
                              // onChange={(v: any, e) => handleInputChange(v, e)}
                              value={formDetails.cpf}
                              error={!!errors.cpf}
                              helperText={errors.cpf}
                              className="textbox"
                            />
                          </Col>
                        </Row>
            
                        <Row>
                          <Col md={6}>
                            <TextBox
                              separateLabel
                              label={t("HPI.CreateCase.Contactinformation.State_Inscription",{defaultValue:'State Inscription'})}
                              required
                              //disabled={flgBrazil.stateInscription ? true : isDisabled }
                              // disabled={flgBrazil.stateInscription }
                              name="stateInscription"
                              placeholder={t('HPI.CreateCase.Placeholder.EnterStateInscription',{defaultValue:'Enter state inscription'})}
                              // onChange={(v: any, e) => handleInputChange(v, e)}
                              value={formDetails.stateInscription}
                              error={!!errors.stateInscription}
                              helperText={errors.stateInscription}
                              className="textbox"
                            />
                          </Col>
                        </Row>
                      </>
                    )}

            <Row className="mt-3 mb-4">

                <Col col={12} md={2}>
                    <Button type="submit" onClick={handleAddContactSubmit}>
                        {t("HPI.btnAddcontact", {
                            defaultValue: "Add contact",
                        })}
                    </Button>
                </Col>
            </Row>
        </form >
    );
};

export default CreateNewContact;